// extracted by mini-css-extract-plugin
export default {"title":"Scheduled_title__Yms8o"};